// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../../queries/fragments.generated';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackagePruneSlotsModal_DataQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type DesignPackagePruneSlotsModal_DataQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }, takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', active: boolean, id: string, name: string, slot: { __typename?: 'ItemSlot', id: string, location: { __typename?: 'Location', id: string, feature?: { __typename?: 'Location', id: string, name: string } | null | undefined, room?: { __typename?: 'Location', id: string, name: string } | null | undefined, nonScopeLocation: { __typename?: 'Location', id: string, name: string } }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, name: string } } } }> } };

export type DesignPackagePruneSlotsModal_SaveDraftMutationVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  input: Array<Types.SaveTakeoffLineItemInput> | Types.SaveTakeoffLineItemInput;
}>;


export type DesignPackagePruneSlotsModal_SaveDraftMutation = { __typename?: 'Mutation', saveTakeoffLineItems: { __typename?: 'SaveTakeoffLineItemResult', takeoffLineItems: Array<{ __typename?: 'TakeoffLineItem', id: string }> } };


export const DesignPackagePruneSlotsModal_DataDocument = gql`
    query DesignPackagePruneSlotsModal_Data($designPackageId: ID!, $versionId: ID!) {
  designPackage(id: $designPackageId, versionId: $versionId) {
    id
    canEdit {
      ...PotentialOperationDetails
    }
  }
  takeoffLineItemsPage(
    filter: {readyPlan: [$designPackageId], hasPlanLines: false}
    versionId: $versionId
    first: 10000
  ) {
    items {
      ...Named
      active
      slot {
        id
        location {
          id
          feature {
            ...Named
          }
          room {
            ...Named
          }
          nonScopeLocation {
            ...Named
          }
        }
        item {
          id
          costCode {
            ...Named
          }
        }
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useDesignPackagePruneSlotsModal_DataQuery__
 *
 * To run a query within a React component, call `useDesignPackagePruneSlotsModal_DataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackagePruneSlotsModal_DataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackagePruneSlotsModal_DataQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDesignPackagePruneSlotsModal_DataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables> & ({ variables: DesignPackagePruneSlotsModal_DataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>(DesignPackagePruneSlotsModal_DataDocument, options);
      }
export function useDesignPackagePruneSlotsModal_DataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>(DesignPackagePruneSlotsModal_DataDocument, options);
        }
// @ts-ignore
export function useDesignPackagePruneSlotsModal_DataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>;
export function useDesignPackagePruneSlotsModal_DataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackagePruneSlotsModal_DataQuery | undefined, DesignPackagePruneSlotsModal_DataQueryVariables>;
export function useDesignPackagePruneSlotsModal_DataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>(DesignPackagePruneSlotsModal_DataDocument, options);
        }
export type DesignPackagePruneSlotsModal_DataQueryHookResult = ReturnType<typeof useDesignPackagePruneSlotsModal_DataQuery>;
export type DesignPackagePruneSlotsModal_DataLazyQueryHookResult = ReturnType<typeof useDesignPackagePruneSlotsModal_DataLazyQuery>;
export type DesignPackagePruneSlotsModal_DataSuspenseQueryHookResult = ReturnType<typeof useDesignPackagePruneSlotsModal_DataSuspenseQuery>;
export type DesignPackagePruneSlotsModal_DataQueryResult = ApolloReactCommon.QueryResult<DesignPackagePruneSlotsModal_DataQuery, DesignPackagePruneSlotsModal_DataQueryVariables>;
export const DesignPackagePruneSlotsModal_SaveDraftDocument = gql`
    mutation DesignPackagePruneSlotsModal_SaveDraft($readyPlanId: ID!, $input: [SaveTakeoffLineItemInput!]!) {
  saveTakeoffLineItems(readyPlanId: $readyPlanId, input: $input) {
    takeoffLineItems {
      id
    }
  }
}
    `;

/**
 * __useDesignPackagePruneSlotsModal_SaveDraftMutation__
 *
 * To run a mutation, you first call `useDesignPackagePruneSlotsModal_SaveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignPackagePruneSlotsModal_SaveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designPackagePruneSlotsModalSaveDraftMutation, { data, loading, error }] = useDesignPackagePruneSlotsModal_SaveDraftMutation({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignPackagePruneSlotsModal_SaveDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DesignPackagePruneSlotsModal_SaveDraftMutation, DesignPackagePruneSlotsModal_SaveDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DesignPackagePruneSlotsModal_SaveDraftMutation, DesignPackagePruneSlotsModal_SaveDraftMutationVariables>(DesignPackagePruneSlotsModal_SaveDraftDocument, options);
      }
export type DesignPackagePruneSlotsModal_SaveDraftMutationHookResult = ReturnType<typeof useDesignPackagePruneSlotsModal_SaveDraftMutation>;
export type DesignPackagePruneSlotsModal_SaveDraftMutationResult = ApolloReactCommon.MutationResult<DesignPackagePruneSlotsModal_SaveDraftMutation>;